import React from 'react';
import { View, Text, Modal, Pressable, useColorScheme } from 'react-native';
import { useThemeColors } from '@/providers/ThemeProvider';

const QUICK_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🙏', '👏', '🔥'];

interface EmojiReactionPickerProps {
  visible: boolean;
  onClose: () => void;
  onSelect: (emoji: string) => void;
}

export const EmojiReactionPicker: React.FC<EmojiReactionPickerProps> = ({
  visible,
  onClose,
  onSelect,
}) => {
  const colors = useThemeColors();
  const colorScheme = useColorScheme();
  const isDark = colorScheme === 'dark';

  const handleSelect = (emoji: string) => {
    onSelect(emoji);
    onClose();
  };

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <Pressable
        style={{ flex: 1, backgroundColor: 'rgba(0,0,0,0.5)', justifyContent: 'center', alignItems: 'center' }}
        onPress={onClose}
      >
        <Pressable
          onPress={(e) => e.stopPropagation()}
          style={{
            backgroundColor: colors.surface,
            borderRadius: 16,
            padding: 20,
            minWidth: 280,
          }}
        >
          <Text
            className="text-sm font-semibold mb-3"
            style={{ color: colors.textSecondary }}
          >
            Reageer met emoji
          </Text>
          <View className="flex-row flex-wrap gap-2">
            {QUICK_EMOJIS.map((emoji) => (
              <Pressable
                key={emoji}
                onPress={() => handleSelect(emoji)}
                className="w-12 h-12 rounded-full items-center justify-center"
                style={{
                  backgroundColor: isDark ? '#374151' : '#E5E7EB',
                }}
              >
                <Text className="text-2xl">{emoji}</Text>
              </Pressable>
            ))}
          </View>
          <Pressable
            onPress={onClose}
            className="mt-4 py-2 rounded-xl items-center"
            style={{ backgroundColor: colors.surfaceSecondary }}
          >
            <Text className="text-base font-medium" style={{ color: colors.textSecondary }}>
              Annuleren
            </Text>
          </Pressable>
        </Pressable>
      </Pressable>
    </Modal>
  );
};
